<template>
  <div>
    <Header v-if="this.userInfo.user.permission == 'super_admin'" />

    <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
    <CoordinateHeader v-if="this.userInfo.user.permission == 'co-ordinator'" />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="py-10">
      <div class="container px-6 mx-auto max-w-[1200px] flex flex-col gap-10">
        <div>

          
          <div class="flex flex-col gap-5" v-if="currentBatchData == null">
            <h1 class="text-primary text-xl font-bold">Batches</h1>

            <div class="grid grid-cols-1  md:grid-cols-3 gap-5 mt-5"> 

              <template class="text-center" v-if="batchList.length == 0">
                No Batches
              </template>

              <div
                v-for="batch in batchList"
                :key="batch"
                class="flex flex-col py-6 rounded-3xl shadow-xl h-full cursor-pointer"
              >
                <div
                  class="lg:px-8 h-full px-6 flex flex-col items-center justify-center gap-4"
                >
                  <!-- {{ batch }} -->

                  <h1 class="font-bold text-xl lg:text-lg prime text-center">
                    {{ batch.year }} 
                  </h1>

                  <button @click="getSemesterList(batch.id, batch)" class="bg-primary text-sm text-white px-6 py-1.5 rounded-full text-center cursor-pointer">Batch Details</button>
                  <!-- <router-link :to="{ name : 'HodSemesters', params: { batch : batch.id } }"
                    class="bg-primary text-sm text-white px-6 py-1.5 rounded-full text-center cursor-pointer"
                  >
                    Batch Details
                  </router-link> -->

                </div>
              </div>
            </div>
            
          </div>


          <div v-if="this.currentSemesterData == null"> 
            <div class="flex flex-col gap-5" v-if="currentBatchData != null">

                <div class="flex cursor-pointer" @click="this.currentBatchData = null"> 
                    <p
                    class="bg-primary text-sm text-white px-6 mt-4 py-1.5 rounded-full text-center cursor-pointer"
                    >
                    Back
                    </p> 
                </div>

                <h1 class="text-primary text-xl font-bold">Semesters of ( {{ currentBatchData.year }} )</h1>
                <div class="grid  grid-cols-1 md:grid-cols-3 gap-5 mt-5">
                    <div
                    v-for="semester in semeterList"
                    :key="semester"
    
                    class="flex flex-col py-6 rounded-3xl shadow-xl h-full cursor-pointer"
                    >
                    <div
                        class="lg:px-8 h-full px-6 flex flex-col gap-4"
                    >
                    
                        <h1 class="font-bold text-lg lg:text-lg prime text-left">
                            Semester {{ semester.semester }}
                        </h1>

                        <p>Batch: {{ currentBatchData.year }} </p>

                        <p>Courses: {{ semester.course.length }}</p>
                        
                        <p
                        @click="getSemesterCourses(semester.id, semester)"
                        class="bg-primary text-white text-sm px-6 mt-4 py-1.5 rounded-full text-center cursor-pointer"
                        >
                        Semester Courses
                        </p>
                    </div>
                    </div>
                </div>
            </div>
          </div>

         
        </div>
      </div>
    </div>
    <!-- section  --> 
    <div
      v-if="isSection"
      @click.self="isSection = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="isSection = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">Add Section</h4>
        <form
          class="w-11/12 mx-auto pb-10"
          ref="addSectionRef"
          @submit.prevent="sectionAdd"
        >
          <label for="title">
            Name
            <span class="text-red-400">*</span>
          </label>
          <input
            id="name"
            type="text"
            required
            class="border border-gray-300 rounded-md text-sm w-full p-2"
          />

          <div class="flex items-center gap-3">
            <button
              :disabled="disable_submit == true"
              type="submit"
              class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
            >
              Add Section
            </button>

            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-6 h-6 object-contain"
            />
          </div>
        </form>
      </div>
    </div>
    <!-- add category  -->
    <div
      v-if="is_CategoryPopup"
      @click.self="is_CategoryPopup = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="is_CategoryPopup = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">Add Category</h4>
        <form class="w-11/12 mx-auto pb-10" @submit.prevent="categoryAdd">
          <label for="title">
            Title
            <span class="text-red-400">*</span>
          </label>
          <input
            id="title"
            type="text"
            required
            class="border border-gray-300 rounded-md text-sm w-full p-2"
          />
          <!-- <button
              type="submit"
              class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
            >
              Add Category
            </button> -->
          <div class="flex items-center gap-3">
            <button
              :disabled="disable_submit == true"
              type="submit"
              class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
            >
              Add Category
            </button>

            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-6 h-6 object-contain"
            />
          </div>
        </form>
      </div>
    </div>
    <!-- Add Department -->
    <div
      v-if="isDepartment"
      @click.self="isDepartment = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="isDepartment = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">
          Add Department
        </h4>
        <form
          class="w-11/12 mx-auto pb-10 flex flex-col gap-4"
          ref="addDepartment"
          @submit.prevent="AddDepartment"
        >
          <div class="flex flex-col gap-1">
            <label for="name">
              Program
              <span class="text-red-400">*</span>
            </label>
            <select
              id="program_name"
              required
              class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
            >
              <option
                v-for="program in programs"
                :key="program.id"
                :value="program.id"
              >
                {{ program.name }}
              </option>
            </select>
          </div>

          <div class="flex flex-col gap-1">
            <label for="name">
              Name
              <span class="text-red-400">*</span>
            </label>
            <input
              id="name"
              type="text"
              required
              class="border border-gray-300 rounded-md text-sm w-full p-2"
            />
          </div>

          <!-- <button
              type="submit"
              class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
            >
              Add Department
            </button> -->
          <div class="flex items-center gap-3">
            <button
              :disabled="disable_submit == true"
              type="submit"
              class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
            >
              Add Department
            </button>

            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-6 h-6 object-contain"
            />
          </div>
        </form>
      </div>
    </div>
    <!-- Add Programs -->
    <div
      v-if="isPrograms"
      @click.self="isPrograms = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="isPrograms = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">Add Programs</h4>
        <form
          class="w-11/12 mx-auto pb-10 flex flex-col gap-2"
          ref="addProgramsRef"
          @submit.prevent="AddPrograms"
        >
          <div class="flex flex-col gap-1">
            <label for="name">
              Name
              <span class="text-red-400">*</span>
            </label>
            <input
              id="name"
              type="text"
              required
              class="border border-gray-300 rounded-md text-sm w-full p-2"
            />
          </div>
          <!-- 
            <button
              type="submit"
              class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
            >
              Add Program
            </button> -->
          <div class="flex items-center gap-3">
            <button
              :disabled="disable_submit == true"
              type="submit"
              class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
            >
              Add Program
            </button>

            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-6 h-6 object-contain"
            />
          </div>
        </form>
      </div>
    </div>
    <!-- Add Course Type -->
    <div
      v-if="isCourseTypePopup"
      @click.self="isCourseTypePopup = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="isCourseTypePopup = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">
          Add Course Type
        </h4>
        <form
          class="w-11/12 mx-auto pb-10 flex flex-col gap-2"
          ref="addCourseTyperRef"
          @submit.prevent="addCourseType"
        >
          <div class="flex flex-col gap-1">
            <label for="name">
              Name
              <span class="text-red-400">*</span>
            </label>
            <input
              id="title"
              type="text"
              required
              class="border border-gray-300 rounded-md text-sm w-full p-2"
            />
          </div>
          <!-- <button
              type="submit"
              class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
            >
              Add Course Type
            </button> -->
          <div class="flex items-center gap-3">
            <button
              :disabled="disable_submit == true"
              type="submit"
              class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
            >
              Add Course Type
            </button>

            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-6 h-6 object-contain"
            />
          </div>
        </form>
      </div>
    </div>
    <!-- Add Language -->
    <div
      v-if="addLanguage"
      @click.self="addLanguage = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="addLanguage = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">Add Language</h4>
        <form
          class="w-11/12 mx-auto pb-10 flex flex-col gap-2"
          ref="addLangRef"
          @submit.prevent="addLanguagePost"
        >
          <div class="flex flex-col gap-1">
            <label for="name">
              Name
              <span class="text-red-400">*</span>
            </label>
            <input
              id="title"
              type="text"
              required
              class="border border-gray-300 rounded-md text-sm w-full p-2"
            />
          </div>
          <!-- <button
              type="submit"
              class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
            >
              Add Language
            </button> -->
          <div class="flex items-center gap-3">
            <button
              :disabled="disable_submit == true"
              type="submit"
              class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
            >
              Add Language
            </button>

            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-6 h-6 object-contain"
            />
          </div>
        </form>
      </div>
    </div>
    <!-- Add Semester -->
    <div
      v-if="isSemesterAdd"
      @click.self="isSemesterAdd = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="isSemesterAdd = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">Add Semester</h4>
        <form
          class="w-11/12 mx-auto pb-10 flex flex-col gap-2"
          ref="addSemesterRef"
          @submit.prevent="addSemester"
        >
          <div class="flex flex-col gap-3">
            <label for="program_name" class="text-sm flex gap-2"
              >Program Name <span class="text-red-400">*</span>
            </label>
            <select
              id="program"
              @change="getProgramsFilterBYid"
              required
              class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3"
            >
              <option value="" disabled>Select Program</option>
              <option
                v-for="program in programs"
                :key="program.id"
                :value="program.id"
              >
                {{ program.name }}
              </option>
            </select>
          </div>

          <!-- Department -->
          <div class="flex flex-col gap-3">
            <label for="department" class="text-sm flex gap-2"
              >Departments <span class="text-red-400">*</span>
            </label>
            <select
              id="department"
              required
              class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3"
            >
              <option value="" disabled>Select Department</option>
              <option
                v-for="department in departments"
                :key="department.id"
                :value="department.id"
              >
                {{ department.name }}
              </option>
            </select>
          </div>

          <div class="flex flex-col gap-1">
            <label for="name">
              Semester
              <span class="text-red-400">*</span>
            </label>
            <input
              id="semester"
              type="text"
              maxlength="3"
              required
              class="border border-gray-300 rounded-md text-sm w-full p-2"
            />
          </div>
          <!-- <button
              type="submit"
              class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
            >
              Add Semester
            </button> -->
          <div class="flex items-center gap-3">
            <button
              :disabled="disable_submit == true"
              type="submit"
              class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
            >
              Add Semester
            </button>

            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-6 h-6 object-contain"
            />
          </div>
        </form>
      </div>
    </div>

    <div
      v-if="isVideoRetry"
      @click.self="isVideoRetry = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div class="flex items-center justify-center gap-3">
          <button
            type="submit"
            class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
          >
            Retry
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";

import axios from "axios";
import { mapGetters } from "vuex";

import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

import FlashMessage from "@/components/FlashMessage.vue";

export default {
  components: {
    Header,
    QuillEditor,
    FlashMessage,
    HodHeader,
    CoordinateHeader,
  },

  // props: ["batchYear", "departmentName", "programName", "semesterName"],

  data() {
    return { 
      currentBatchData: null,
      batchList: [],
      currentBatchData: null,
      semeterList: [],
      currentSemesterData: null,


      categories: null,
      info: null,
      msgverify: "",
      messages: {
        text: "",
        type: "null",
      },
      batch_years: [],
      programs: [],
      departments: [],
      isDepartment: false,
      isPrograms: false,
      instructor_lists: [],
      courseTypeList: [],
      isCourseTypePopup: false,
      addLanguage: false,
      languageList: [],
      semetser_list: [],
      isSemesterAdd: false,
      sections: [],
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  mounted() { 
  },

  async created() {
    this.getBatchList();
    this.getPrograms();
    this.getCourseTypeList();
    this.getLanguages();
    this.sectionsGet();

    // this.getInstructorListByFilter();

    axios
      .get(
        `${process.env.VUE_APP_API}/batch-list/?Key=${this.userInfo.token_key}`
      )
      .then((res) => {
        this.batch_years = res.data.data;
      });

    axios
      .get(`${process.env.VUE_APP_API}/category/?format=json`)
      .then((res) => {
        this.categories = res.data.data;
      });
  },

  methods: { 

  

   
    getBatchList() {
      axios
        .get(
          `${process.env.VUE_APP_API}/batch-list/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.batchList = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    

    getSemesterList(id, data) {
        this.semeterList =[];
      this.currentBatchData = data;

      axios
        .get(
          `${process.env.VUE_APP_API}/hod/semesters-list/${id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.semeterList = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },


    getSemesterCourses(id, data) {
        this.courseList =[];
        this.semesterId = id;
      this.currentSemesterData = data;
      axios
        .get(
          `${process.env.VUE_APP_API}/hod/course-list/${id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.courseList = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }, 

    getDepartmentFilterBYid(program) {
      // let program = document.getElementById("program").value;
      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}&program__id=${program}`
        )
        .then((res) => {
          this.departments = res.data.data;
        });
    },

    getPrograms() {
      axios
        .get(
          `${process.env.VUE_APP_API}/program-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.programs = res.data.data;
        });
    },
   

    sectionAdd() {
      this.disable_submit = true;
      axios
        .post(
          `${process.env.VUE_APP_API}/section-create/?Key=${this.userInfo.token_key}`,
          { name: document.getElementById("name").value }
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.messages = {
              text: "Section Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.sectionsGet();
              this.isSection = false;
              this.$refs.addSectionRef.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

   
    

    sectionsGet() {
      axios
        .get(
          `${process.env.VUE_APP_API}/section-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.sections = res.data.data;
        });
    },

    addSemester(el) {
      this.disable_submit = true;
      let bodyVal = {
        semester: el.target.elements.semester.value,
        department: document.getElementById("department").value,
        batch: 1,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/semetser-create/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Semester Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.isSemesterAdd = false;
              this.disable_submit = false;
              window.location.reload();
              this.$refs.addSemesterRef.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    getSemesterFilter(index, department_id) {
      let batch_year = 1;
      // let department_name = document.getElementById("department").value;
      console.log(index);
      axios
        .get(
          `${process.env.VUE_APP_API}/semetser-get/?Key=${this.userInfo.token_key}&department__id=${department_id}&batch__id=${batch_year}`
        )
        .then((res) => {
          // this.semetser_list = res.data.data;
          this.formsDetails[index].semetser_list = res.data.data;
        });
    },

    getLanguages() {
      axios
        .get(
          `${process.env.VUE_APP_API}/language/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.languageList = res.data.data;
        });
    },

    addLanguagePost(el) {
      this.disable_submit = true;
      let bodyVal = {
        title: el.target.elements.title.value,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/language/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.messages = {
              text: "Language Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.addLanguage = false;
              this.getLanguages();
              this.$refs.addLangRef.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    addCourseType(el) {
      this.disable_submit = true;
      let bodyVal = {
        title: el.target.elements.title.value,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/course_type/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.messages = {
              text: "Course Type Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.isCourseTypePopup = false;
              this.getCourseTypeList();
              this.$refs.addCourseTyperRef.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    getCourseTypeList() {
      axios
        .get(
          `${process.env.VUE_APP_API}/course_type/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.courseTypeList = res.data.data;
        });
    },

    getInstructorListByFilter(index, department_id) {
      // let department_name = document.getElementById("department").value;
      console.log(index);
      axios
        .get(
          `${process.env.VUE_APP_API}/instructor_all/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          // this.instructor_lists = res.data.products;
          this.formsDetails[index].instructor_lists = res.data.products;
        });
    },

    getProgramsFilterBYid() {
      let program = document.getElementById("program").value;
      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}&program__id=${program}`
        )
        .then((res) => {
          this.departments = res.data.data;
        });
    },

    getProgramsFilter(index, program_id) {
      // let program_name = document.getElementById("program_name").value;
      console.log(index);
      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}&program__id=${program_id}`
        )
        .then((res) => {
          // this.departments = res.data.data;
          this.formsDetails[index].departments = res.data.data;
        });
    },

    AddPrograms(el) {
      this.disable_submit = true;
      let bodyVal = {
        name: el.target.elements.name.value,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/program_create/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.messages = {
              text: "Program Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.isPrograms = false;
              this.getPrograms();
              this.$refs.addProgramsRef.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    getPrograms() {
      axios
        .get(
          `${process.env.VUE_APP_API}/program-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.programs = res.data.data;
        });
    },

    getDepartments() {
      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.departments = res.data.data;
        });
    },

    categoryget() {
      axios
        .get(`${process.env.VUE_APP_API}/category/?format=json`)
        .then((res) => {
          this.categories = res.data.data;
        });
    },

    AddDepartment(el) {
      this.disable_submit = true;
      let bodyVal = {
        name: el.target.elements.name.value,
        program: el.target.elements.program_name.value,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/department_create/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.messages = {
              text: "Department Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.isDepartment = false;
              this.getDepartments();
              this.$refs.addDepartment.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    categoryAdd(el) {
      this.disable_submit = true;
      let bodyVal = {
        title: el.target.elements.title.value,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/categorynew/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.message == "your Category added successfully") {
            this.messages = {
              text: "Category Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.is_CategoryPopup = false;
              this.categoryget();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
